import PageFrame from "components/Panels/PageFrame";
import LockerWrapper from "./LockerWrapper";

const LockerService = () => {
  return <PageFrame children={<LockerWrapper />} />;
};
export default LockerService;
